import { render, staticRenderFns } from "./ChartColorsLegend.vue?vue&type=template&id=1cc8a33f&scoped=true&"
import script from "./ChartColorsLegend.vue?vue&type=script&lang=js&"
export * from "./ChartColorsLegend.vue?vue&type=script&lang=js&"
import style0 from "./ChartColorsLegend.vue?vue&type=style&index=0&id=1cc8a33f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc8a33f",
  null
  
)

export default component.exports